import styled, { css } from "styled-components";
import { COLORS } from "../../styles/constants.style";
import { StatusBadgeType, STATUS_BADGE_TYPE } from "./StatusBadge";

const getStatusStyles = (status: StatusBadgeType) => {
  switch (status) {
    case STATUS_BADGE_TYPE.inActive:
    case STATUS_BADGE_TYPE.notRegistered:
    case STATUS_BADGE_TYPE.unableToValidate:
    case STATUS_BADGE_TYPE.willNotComplete:
    case STATUS_BADGE_TYPE.notYetStarted:
    case STATUS_BADGE_TYPE.scheduled:
    case STATUS_BADGE_TYPE.assignedEnrollment:
    case STATUS_BADGE_TYPE.inQueue:
      return css`
        background-color: ${COLORS.cirrus_black1};
        color: ${COLORS.cirrus_black8};
        border: 2px solid ${COLORS.cirrus_black8};
      `;
    case STATUS_BADGE_TYPE.awaitingEffectiveDate:
    case STATUS_BADGE_TYPE.open:
      return css`
        background-color: ${COLORS.primary_light_blue1};
        color: ${COLORS.primary_light_blue};
        border: 2px solid ${COLORS.primary_light_blue};
      `;

    case STATUS_BADGE_TYPE.closed:
      return css`
        background-color: ${COLORS.cirrus_red_mild};
        color: ${COLORS.cirrus_brown};
        border: 2px solid ${COLORS.cirrus_brown};
      `;
    case STATUS_BADGE_TYPE.inProgress:
      return css`
        background-color: ${COLORS.cirrus_orange_light1};
        color: ${COLORS.cirrus_orange_dark2};
        border: 2px solid ${COLORS.cirrus_orange_dark2};
      `;
    case STATUS_BADGE_TYPE.reversed:
    case STATUS_BADGE_TYPE.expired:
    case STATUS_BADGE_TYPE.ineligible:
    case STATUS_BADGE_TYPE.createdInError:
      return css`
        background-color: ${COLORS.cirrus_red_mild1};
        color: ${COLORS.cirrus_red};
        border: 2px solid ${COLORS.cirrus_red};
      `;
    case STATUS_BADGE_TYPE.unBilled:
    case STATUS_BADGE_TYPE.hold:
    case STATUS_BADGE_TYPE.noLongerValid:
      return css`
        background-color: ${COLORS.cirrus_olive_green_light};
        color: ${COLORS.cirrus_olive_green1};
        border: 2px solid ${COLORS.cirrus_olive_green};
      `;
    case STATUS_BADGE_TYPE.cancelled:
    case STATUS_BADGE_TYPE.archived:
      return css`
        background-color: ${COLORS.primary_light_blue1};
        color: ${COLORS.cirrus_black9};
        border: 2px solid ${COLORS.cirrus_black9};
      `;
    case STATUS_BADGE_TYPE.autoRenewed:
    case STATUS_BADGE_TYPE.conCon:
    case STATUS_BADGE_TYPE.all:
      return css`
        background-color: ${COLORS.cirrus_violet_light1};
        color: ${COLORS.cirrus_violet1};
        border: 2px solid ${COLORS.cirrus_violet1};
      `;
    case STATUS_BADGE_TYPE.executed:
    case STATUS_BADGE_TYPE.completed:
    default:
      return css`
        background-color: ${COLORS.cirrus_green_light};
        color: ${COLORS.cirrus_green1};
        border: 2px solid ${COLORS.cirrus_green1};
      `;
  }
};

export const StatusBadgeWrapper = styled.div<{ status: StatusBadgeType }>`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  min-width: 24px;
  min-height: 24px;
  margin: 5px 0px;
  padding: 3px 6px;
  gap: 8px;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 700;
  line-height: 1;
  text-transform: capitalize;
  ${({ status }) => getStatusStyles(status)}
  .icon {
    height: 16px;
    width: 16px;
    stroke: currentColor;
    stroke-width: 1;
  }
  .rotated-icon {
    height: 16px;
    width: 16px;
    stroke: currentColor;
    stroke-width: 1;
    transform: rotate(45deg);
  }
`;
